<template>
  <svg width="8" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M.744.411a.833.833 0 0 1 1.179 0l5 5a.833.833 0 0 1 0 1.179l-5 5A.833.833 0 0 1 .744 10.41l4.41-4.41L.745 1.59a.833.833 0 0 1 0-1.179Z"
      fill="#153D49"
    />
  </svg>
</template>
